import { jsx as i } from "react/jsx-runtime";
import { c as s } from "react/compiler-runtime";
import { Step as f } from "@mui/material";
import { forwardRef as l } from "react";
const d = l((p, m) => {
  const o = s(7);
  let r, t;
  o[0] !== p ? ({
    children: r,
    ...t
  } = p, o[0] = p, o[1] = r, o[2] = t) : (r = o[1], t = o[2]);
  let e;
  return o[3] !== r || o[4] !== t || o[5] !== m ? (e = /* @__PURE__ */ i(f, { ref: m, ...t, children: r }), o[3] = r, o[4] = t, o[5] = m, o[6] = e) : e = o[6], e;
});
export {
  d as Step
};
